export const ANIMATION_TIMEOUT = 700;
